import { Link, Stack, Typography, type StackProps } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { formatMoney } from '@/utils/masks/money';

interface SummaryBoxItem {
  label: string;
  value: string | number | null;
  detail?: string | null;
}

interface SummaryBoxProps extends StackProps {
  items: SummaryBoxItem[];
}

export const SummaryBox = ({ items, sx, ...props }: SummaryBoxProps) => (
  <Stack
    gap={3}
    py={2}
    px={{ xs: 1, md: 3 }}
    sx={[
      ({ palette }) => ({ border: `1px solid ${palette.divider}` }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
  >
    {items.map(({ label, value, detail }) => (
      <Stack key={label}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h3" fontWeight={fontWeights.fontWeightSemibold}>
            {label}
          </Typography>
          <Typography variant="h3" fontWeight={fontWeights.fontWeightSemibold}>
            {formatMoney(value ?? '')}
          </Typography>
        </Stack>
        {detail && (
          <Typography variant="body2" mt={1}>
            {detail}{' '}
            <Link
              href="/meus-reembolsos/minhas-politicas"
              target="_blank"
              color="info.main"
              sx={{ fontSize: 'inherit' }}
            >
              Ver regras
            </Link>
            .
          </Typography>
        )}
      </Stack>
    ))}
  </Stack>
);
